module.exports = __webpack_public_path__ + "static/spanish-online-banner-091c2e20496f3bdf095739ba66629511.svg";